import React from 'react';
import { connect } from 'react-redux';
import { updateUserOrgAction } from '../../redux/actions/user';

import UsersLoader from '../loaders/UsersLoader';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import Selector from './Selector';

import './organization-selector.css';

const OrganizationSelector = ({ organizations, orgId, updateOrg }) => (
  <>
    <UsersLoader />
    <OrganizationsLoader />
    <Selector
      options={organizations.map((org) => ({
        id: org.id,
        key: `${org.id}`,
        display: org.name,
      }))}
      selected={orgId}
      onChange={(e) => {
        updateOrg(organizations.filter(({ id }) => id === e.target.value)[0]);
      }}
      disabled={organizations.length <= 1}
      className="org-selector"
    />
  </>
);

const mapStateToProps = (state) => {
  const {
    users: { organizations },
    user: { orgId },
  } = state;
  return {
    organizations,
    orgId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateOrg: (org) => dispatch(updateUserOrgAction(org)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationSelector);
